import React from 'react';
// import { ReactTyped } from 'react-typed'; // Correct import
import { Container, Row, Col } from 'react-bootstrap';
import ConstructionEngineering from './ConstructionEngineering';
import Contact from './Contact';
import { useEffect } from 'react';
const currentYear = new Date().getFullYear();
function LandingSection() {
  return (
    <section className="landing-section text-center py-5">
      <img
          src="/assets/logo.png" // <-- Your logo path
          alt="Logo"
          style={{ width: '40%', height: 'auto' }}
        />
      <h1 className="display-4 fw-bold mb-3">
        
        Discover your next with R&P Travels
      </h1>
      {/* <h2 className="display-6 fw-semibold">
        <ReactTyped
          strings={['adventure', 'flight booking', 'travel journey']}
          typeSpeed={100}
          backSpeed={50}
          loop
          showCursor={true}
          cursorChar="|"
        />
      </h2> */}
    </section>
  );
}

function Home() {
    useEffect(() => {
        const scrollTo = localStorage.getItem('scrollTo');
        if (scrollTo) {
          // Delay to ensure DOM is fully rendered
          const timeout = setTimeout(() => {
            const el = document.getElementById(scrollTo);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
            }
            localStorage.removeItem('scrollTo');
          }, 100); // You can increase to 300ms if needed
      
          return () => clearTimeout(timeout); // Cleanup
        }
      }, []);
      
  return (
    <div>

      {/* Hero section (Landing Page) */}
      <div className="landing-page d-flex flex-column justify-content-center align-items-center" id="home">
      
        <LandingSection />

      </div>

      {/* About Us Section with image */}
      <section id="about" className="content-section">
        <Container>
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-up" data-aos-delay="200">
              <h2 className="section-title">About Us</h2>
              <p className="section-text">
                R&P Travels is your trusted partner for travel solutions and overseas manpower recruitment.
                Based in Krishnagar, Nadia, we proudly offer a full range of services — from travel bookings
                to international job placements. Our team is committed to making your travel dreams come true
                and helping candidates achieve career success abroad.
              </p>
              <p className="section-text">
                With years of experience and a reputation built on integrity, transparency, and client satisfaction,
                R&P Travels ensures a smooth and professional experience whether you’re planning a trip or seeking overseas employment.
              </p>
            </Col>
            <Col md={6} data-aos="fade-up" data-aos-delay="600">
              <img 
                src="/assets/img9.jpeg" 
                alt="Travel" 
                className="about-img"
              />
            </Col>
          </Row>
        </Container>
      </section>

 {/* Services Section */}
<section id="services" className="content-section">
  <Container>
    <h2 className="section-title">Our Services</h2>

    {/* Travel Solutions */}
    <Row className="align-items-center mb-5">
      <Col md={6} data-aos="fade-up" data-aos-delay="200">
        <img src="/assets/img3.jpg" alt="Travel Solutions" className="img-fluid rounded other-img" />
      </Col>
      <Col md={6} data-aos="fade-up" data-aos-delay="600" className='mt-4'>
        <h4>Travel Solutions</h4>
        <p>Air Ticket Booking (Domestic & International)</p>
        <p>Passport and Visa Assistance</p>
      </Col>
    </Row>

    {/* Manpower and Placement Services */}
    <Row className="align-items-center mb-5 flex-md-row-reverse">
      <Col md={6} data-aos="fade-up" data-aos-delay="200">
        <img src="/assets/img4.jpg" alt="Manpower Services" className="img-fluid rounded other-img" />
      </Col>
      <Col md={6} data-aos="fade-up" data-aos-delay="600" className='mt-4'>
        <h4>Manpower and Placement Services</h4>
        <p>Overseas Job Placement</p>
        <p>Resume Preparation and Interview Guidance</p>
        <p>Visa Processing Support</p>
        <p>Pre-Departure Briefings</p>
        <p>Skilled, Semi-Skilled, and Professional Recruitment</p>
        <p>Abroad Job and Immigration Assistance</p>
      </Col>
    </Row>

    
    <ConstructionEngineering />

    {/* Why Choose Us */}
    <Row className="align-items-center mb-5 content-section">
      <Col md={6} data-aos="fade-up" data-aos-delay="200">
        <img src="/assets/img5.jpg" alt="Why Choose Us" className="img-fluid rounded other-img" />
      </Col>
      <Col md={6} data-aos="fade-up" data-aos-delay="600" className='mt-4'>
        <h4>Why Choose R&P Travels?</h4>
        <p>Trusted Travel and Placement Experts</p>
        <p>Wide International Network</p>
        <p>Transparent and Fast Processes</p>
        <p>Personalized Service for Every Client</p>
        <p>End-to-End Support — from Application to Arrival</p>
      </Col>
    </Row>
    
  </Container>
</section>


      {/* Mission Section */}
      <section id="mission" className="content-section" >
        <Container data-aos="fade-up" data-aos-delay="300">
          <h2 className="section-title">Mission/Vision</h2>
          <p className="section-text">
            To connect people with global opportunities and create unforgettable travel experiences through quality service and dedication.
          </p>
        </Container>
      </section>

      <Contact />



    <footer>
      <p className="text-center">&#169; {currentYear} R&P Travels. All rights reserved.</p>
    </footer>
    </div>
  );
}

export default Home;
